import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
// eslint-disable-next-line import/no-cycle
import { layoutClasses, getImageSizesForGridLayout } from './grid-utils';
require("./grid-container.css");
var styles = {
  "gridContainer": "gridContainer-Yq5tH",
  "gridListWrapper": "gridListWrapper-32JPI",
  "gridLayout": "gridLayout-3lLz_",
  "oneColumnNarrow": "oneColumnNarrow-18T12",
  "oneColumnMid": "oneColumnMid-1XXHb",
  "twoColumn": "twoColumn-20zag",
  "twoColumnRight": "twoColumnRight-2vDyr",
  "twoColumnLeft": "twoColumnLeft-5r51M",
  "twoColumnNarrowSplit": "twoColumnNarrowSplit-1E-jv",
  "threeColumn": "threeColumn-DXNLn",
  "fourColumn": "fourColumn-qzGWg",
  "heading": "heading-3MMsO",
  "centerAligned": "centerAligned-omTBA"
};
var GridContainer = _ref => {
  var {
    children,
    className,
    heading,
    layout,
    renderAsList,
    align
  } = _ref;
  var layoutClass = layoutClasses[layout];
  var InnerWrapper = renderAsList ? 'ul' : 'div';
  var ChildWrapper = renderAsList ? 'li' : React.Fragment;
  var imageSizes = useMemo(() => {
    return getImageSizesForGridLayout(layout);
  }, [layout]);
  if (!children) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.gridContainer, className, {
      [styles.centerAligned]: align === 'center'
    }),
    "data-testid": "grid-container"
  }, !!heading && /*#__PURE__*/React.createElement("div", {
    className: cs('lll-grid lll-grid-padding', styles.gridLayout, styles.heading, {
      [styles.oneColumnNarrow]: layoutClass === 'oneColumnNarrow' || layoutClass === 'twoColumnNarrowSplit'
    }, {
      [styles.oneColumnMid]: layoutClass === 'oneColumnMid'
    })
  }, heading), /*#__PURE__*/React.createElement(InnerWrapper, {
    className: cs('lll-grid lll-grid-padding', styles.gridLayout, styles[layoutClass], {
      [styles.gridListWrapper]: renderAsList
    }),
    "data-testid": "grid-inner-wrapper"
  }, React.Children.map(children, (child, index) => {
    var columnIndex = index % imageSizes.length;
    return /*#__PURE__*/React.createElement(GridContainerContext.Provider, {
      value: imageSizes[columnIndex]
    }, /*#__PURE__*/React.createElement(ChildWrapper, null, child));
  })));
};
GridContainer.defaultProps = {
  align: 'left',
  className: '',
  heading: null,
  layout: '1 Column - Wide',
  renderAsList: false
};
GridContainer.propTypes = {
  /** Alignment for the content within the grid. */
  align: PropTypes.oneOf(['left', 'center']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** Optional <Heading /> to be rendered above the grid container. */
  heading: PropTypes.node,
  /** Layout options for how content is distributed across columns. */
  layout: PropTypes.oneOf(['1 Column - Wide', '1 Column - Mid', '1 Column - Narrow', '2 Columns - Wide Split', '2 Columns - Right Feature', '2 Columns - Left Feature', '2 Columns - Narrow Split', '3 Columns', '4 Columns - Wide']),
  /** Control whether the children will be rendered as an unordered list. */
  renderAsList: PropTypes.bool
};
export var GridContainerContext = /*#__PURE__*/React.createContext();
export default GridContainer;